<template>
  <div>
    <ServiceRequestCreate ref="serviceRequestCreate" :policy="policy" :serviceRequestType="serviceRequestKey" :initialID="ID" @onDataRetrived="onDataRetrived">
      <div slot="serviceRequestType" slot-scope="row">
        <div v-if="!row.status || row.status === 'PEN'">
          <FITSelect :rule="{required:true}" field="premiumType" :label="getLabel('premiumType')" v-model="form.premiumType" :options="premiumType" :width="columnWidth" :disabled="row.isLocked"></FITSelect>
        </div>
        <div v-else>
          <ServiceRequestDetailRow :field="getLabel('premiumType')" :value="getTranslatedString($i18n.locale,'premiumType',form.premiumType)"></ServiceRequestDetailRow>
        </div>
      </div>
    </ServiceRequestCreate>
  </div>
</template>
<script type="text/javascript">
import ServiceRequestCreate from '../ServiceRequestCreate'

import {
  FITTextInput,
  FITButton,
  FITAutoSearch,
  FITSelect,
  FITTextarea,
  FITDatePicker
} from '@/components'
import ServiceRequestDetailRow from '../ServiceRequestDetailRow'
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
export default {
  name: 'ChangePaymentMode',
  components: {
    ServiceRequestCreate,
    FITTextInput,
    FITButton,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITTextarea,
    ServiceRequestDetailRow
  },

  methods: {
    getLabel(field) {
      return this.$t(`osm.serviceRequest.type.${this.serviceRequestKey}.${field}`);
    },

    onDataRetrived(data) {
      this.selectedType.list
        .forEach((column) => {
          Vue.set(this.form, column.fieldColumn, this.selectedType.data[column.fieldColumn])
        })
    }
  },

  data() {
    return {
      type: {},
      form: {
        premiumType: ''
      },
      serviceRequestKey: 'CPO'
    }
  },

  props: {
    ID: {
      type: Number,
      default: null
    },

    policy: {
      type: Object,
      default: null
    }
  },

  computed: {
    columnWidth() {
      if (this.$refs.serviceRequestCreate) {
        return this.$refs.serviceRequestCreate.option.data.column;
      }
      return 10;
    },

    ...mapGetters('ServiceRequest', [
      'getTranslated',
      'getTranslatedArray',
      'getTranslatedString',
      'isValueModified',
      'getServiceRequestTranslated'
    ]),

    ...mapState('ServiceRequest', [
      'fields',
      'selectedType'
    ]),

    premiumType() {
      return this.getTranslated(this.$i18n.locale, 'premiumType', 'selectedType');
    },

    companyBank() {
      return this.getTranslated(this.$i18n.locale, 'companyBank', 'selectedType');
    }
  },

  created() {
    if (!this.policy) {
      console.debug(this.serviceRequestKey, 'Null policy ID when routing to service request');
      return
    }

    // this.$store.dispatch('ServiceRequest/getFields', {
    //     type: this.serviceRequestKey,
    //     ...this.policy
    //   })
    //   .then((json) => {
    //     this.selectedType.list
    //       .forEach((column) => {
    //         Vue.set(this.form, column.fieldColumn, this.selectedType.data[column.fieldColumn])
    //       })
    //   })
    //   .catch((err) => {

    //   })
  },

  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$store.commit({
          type: 'ServiceRequest/setTypeForm',
          form: JSON.parse(JSON.stringify(val))
        })
      }
    },
    'selectedType.data': {
      deep: true,
      handler(val) {
        console.debug(val)
        Vue.set(this.form, 'ID', val.ID);
      }
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/components/ServiceRequestTypes/ChangePaymentMode.vue